import Ten99Saga from 'Agent/1099s/sagas/Ten99Saga';
import {watchFetchAccountDetails, fetchAccountImages} from 'Agent/Accounts/ducks/accountDetail';
import accountSaga from 'Agent/Accounts/sagas/accountSaga';
import discrepancySummarySaga from 'Agent/Accounts/sagas/discrepancySummarySaga';
import enrollmentApplicationSaga from 'Agent/Accounts/sagas/enrollmentApplicationSaga';
import agentsSaga from 'Agent/AgentInformation/sagas';
import agentDocumentationSaga from 'Agent/AgentDocumentation/sagas';
import {watchFetchClaims} from 'Agent/Claims/ducks/claim';
import claimSaga from 'Agent/Claims/sagas';
import commissionsSaga from 'Agent/Commissions/sagas';
import policyApplicationsSaga from 'Agent/Policies/sagas/policyApplicationsSaga';
import policyCorrespondenceSaga from 'Agent/Policies/sagas/policyCorrespondenceSaga';
import policySaga from 'Agent/Policies/sagas/policySaga';
import policyServiceRequestSaga from 'Agent/Policies/sagas/policyServiceRequestSaga';
import NewsSaga from 'AgentNewsAdministration/sagas';
import beneficiariesSaga from 'Beneficiaries/sagas/beneficiariesSaga';
import bosToolsSaga from 'BOSTools/sagas/bosToolsSaga';
import {deleteAlertSaga, getAlertSaga, getAlertsSaga, getUserAlertsSaga, saveAlertSaga} from 'Core/ducks/alerts';
import coreSaga from 'Core/sagas';
import legalAcceptanceSaga from 'Core/sagas/legalAcceptanceSaga';
import legalDocumentSaga from 'Core/sagas/legalDocumentSaga';
import enrollmentFileSaga from 'Enrollment/sagas/enrollmentFileSaga';
import employerEnrollmentSaga from 'Enrollment/sagas/employerEnrollmentSaga';
import enrollTrackUserSaga from 'Enrollment/sagas/enrollTrackUserSaga';
import {all} from 'redux-saga/effects';
import userSaga from 'Users/sagas';
import systemAdministrationSaga from 'SystemAdministration/sagas';
// import messagingSaga from 'GenericTexting/sagas/messagingSaga';
import appEntrySaga from 'ApplicationEntry/sagas';

export default function* rootSaga() {
  while (true) {
    try {
      yield all([
        NewsSaga(),
        Ten99Saga(),
        accountSaga(),
        agentDocumentationSaga(),
        agentsSaga(),
        beneficiariesSaga(),
        bosToolsSaga(),
        claimSaga(),
        commissionsSaga(),
        coreSaga(),
        deleteAlertSaga(),
        discrepancySummarySaga(),
        employerEnrollmentSaga(),
        enrollTrackUserSaga(),
        enrollmentApplicationSaga(),
        enrollmentFileSaga(),
        getAlertSaga(),
        getAlertsSaga(),
        getUserAlertsSaga(),
        legalAcceptanceSaga(),
        legalDocumentSaga(),
        policyApplicationsSaga(),
        policyCorrespondenceSaga(),
        policySaga(),
        policyServiceRequestSaga(),
        systemAdministrationSaga(),
        saveAlertSaga(),
        userSaga(),
        watchFetchAccountDetails(),
        fetchAccountImages(),
        watchFetchClaims(),
        // messagingSaga(),
        appEntrySaga(),
      ]);
    } catch (e) {
      console.error('saga aborted due to:', e);
      console.log('restarting the saga...');
    }
  }
}
